var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaishenpi = function SvgDaishenpi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 25.5H3.308a.822.822 0 0 1-.808-.832c0-.458.363-.792.808-.792h19.384c.444 0 .808.334.808.792a.823.823 0 0 1-.808.832Zm0-3.029H3.308a.822.822 0 0 1-.808-.832v-4.16c0-1.373 1.09-2.496 2.423-2.496h5.17c-.162-.999-.647-1.955-1.333-2.788a5.918 5.918 0 0 1-1.414-3.868c0-1.581.606-3.08 1.737-4.202 1.13-1.124 2.584-1.664 4.16-1.623 2.907.125 5.37 2.704 5.41 5.7.041 1.497-.524 2.953-1.494 4.077-.686.749-1.09 1.664-1.251 2.704h5.169c1.332 0 2.423 1.123 2.423 2.496v4.16a.823.823 0 0 1-.808.832ZM4.115 20.807h17.77v-3.328a.823.823 0 0 0-.808-.832h-6.058a.822.822 0 0 1-.808-.832c0-1.747.606-3.412 1.737-4.66.727-.79 1.09-1.83 1.09-2.912-.04-2.163-1.777-3.994-3.877-4.077a3.86 3.86 0 0 0-2.948 1.165 4.185 4.185 0 0 0-1.252 2.996c0 .998.364 1.996 1.01 2.745 1.17 1.373 1.817 3.037 1.817 4.743a.822.822 0 0 1-.808.832H4.923a.822.822 0 0 0-.808.832v3.328Z",
    fill: "#323333",
    fillRule: "nonzero"
  })));
};

export default SvgDaishenpi;